import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, forwardRef, HostListener, Inject, Input, ViewChild } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Keys } from '@skylab-shared/ui';

import { EventBus, EventBusBase } from '@skylab-angular-shared/core';

import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { TooltipDirective } from '../tooltip/tooltip.directive';
import { ValidateDirective } from '../validation/validate.directive';
import { TextValueAccessorDirective } from '../value-accessors/text-value-acessor.directive';
import { ValueAccessor } from '../value-accessors/value-accessor';
import { IconComponent } from '../icon/icon.component';

@Component({
    templateUrl: './password.component-ins.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PasswordComponentIns),
            multi: true,
        },
    ],
    selector: 'skl-password-ins',
    styles: [`
        :host {
            display: inline-block;
            width: 100%;
            display: flex;
        }

        ins-input {
            width: inherit;
        }
    `],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [TextValueAccessorDirective, FormsModule, ValidateDirective, TooltipDirective, TranslatePipe, IconComponent]
})
export class PasswordComponentIns extends ValueAccessor {
    @Input() public placeholder!: string;
    @Input() public validationKey!: string | null | undefined | (undefined | null | string)[];
    @ViewChild('inputRef', {static: true}) protected inputRef!: ElementRef<HTMLInputElement>;

    public showPassword = false;

    public constructor(
        @Inject(EventBus) eventBus: EventBusBase,
        elementRef: ElementRef
    ) {
        super(elementRef, eventBus);
    }

    public override writeValue(value: any): void {
        this.element.value = this.currentValue = value;
    }

    public onMouseDown(): void {
        this.showPassword = true;
    }

    public onMouseUp(): void {
        this.showPassword = false;
    }

    public override registerOnChange(fn: (value: any) => void): void {
        super.registerOnChange(value => {
            fn(value);
        });
    }

    public override registerOnTouched(fn: () => void): void {
        super.registerOnTouched(() => {
            fn();
        });
    }

    @HostListener('keyup', ['$event'])
    protected handleEnter(event: KeyboardEvent): void {
        if (event.keyCode === Keys.Enter) {
            this.handleBlurEvent(event.target as HTMLInputElement);
        }
    }

    @HostListener('insBlur', ['$event.target'])
    protected override handleBlurEvent(elm: unknown): void {
        if (elm === this.element) {
            this.handleChangeEvent(elm as HTMLInputElement, (elm as HTMLInputElement).value);
            this.onTouched();
        }
    }

    protected override get element(): any {
        return this.inputRef?.nativeElement as HTMLInputElement;
    }
}
